import { Link } from '../link';
import { Trans } from 'react-i18next';
import { withSiteMeta } from '../../HOCS/withSiteMeta';
import { FC } from 'react';

type TMainNavStreamingNoticeProps = {
  searchUrl?: string;
  siteConfig: any;
  className?: string;
};

const MainNavStreamingNoticeBase: FC<TMainNavStreamingNoticeProps> = (props) => {
  const { streamers } = props.siteConfig;

  if (streamers.count > 1) {
    const content = (
      <>
        <i className="rio-profile-links rio-profile-links--small slds-avatar slds-avatar--x-small twitch slds-m-right--xx-small" />
        <b key={`streaming:players:${streamers.count}`}>
          <Trans i18nKey="nav:streaming.count-live-now" values={{ count: streamers.count }}>
            <span className="text-raiderio" />
          </Trans>
        </b>
      </>
    );

    if (props.searchUrl) {
      return (
        <div className={props.className}>
          <Link
            className="rio-realm-link"
            to={props.searchUrl}
            onClick={() => {
              RIO_TRACK_EVENT('event', 'select_content', {
                content_type: 'streaming_characters'
              });
              return true;
            }}
          >
            {content}
          </Link>
        </div>
      );
    } else {
      return <div className={props.className}>{content}</div>;
    }
  }

  return null;
};

export const MainNavStreamingNotice = withSiteMeta(MainNavStreamingNoticeBase);
